<template>
<div class='convert-wrapper'>
  <h1>正在生成中，大概需要 {{estimatedTime.lowerEt}} - {{estimatedTime.upperEt}} 分钟，请稍候...</h1>
  <div class='progress-wrapper'>
    <!-- <el-progress class='convert-progress' type="circle" :percentage="25" :width='200'></el-progress> -->
    <spinner class="spinner" :size="160" :text="$t(`project.state.${project.state}`)" />
    <div class='background-image img'></div>
  </div>

  <p class='hint'>{{$t('hint.project.convert.secondary')}}</p>

  <div class='qrcode wechat' v-if="!user.wechat_mp_connected && wxConnection.url && !tbcMode">
    <div class='img' :style="{backgroundImage: 'url('+'//qrcode.ppj.io/'+ wxConnection.url + ')'}"></div>
    <p class='hint' v-html="$t('qrcode.convert')"></p>
  </div>
</div>
</template>

<script>
export default {
  computed: {
    project() {
      return this.$store.state.project.items[this.$route.params.id]
    },
    wxConnection() {
      return this.$store.state.user.wxConnection
    },
    estimatedTime() {
      return this.$store.state.project.checks[this.project.id] || { lowerEt: 1, upperEt: 3 }
    }
  }
}
</script>

<style lang='scss' scoped>
$progress-width: 200px;
// change might also need apply to attributes in template
.convert-wrapper {
    position: relative;
    h1 {
        margin-top: 60px;
        margin-bottom: $margin-base;
    }

    .progress-wrapper {
        position: relative;
        margin: $margin-base;
        height: $progress-width;

        .spinner {
            position: absolute;
            left: 50%;
            margin-left: -80px;
            margin-top: 2em;
            background-color: $color-white-base;
            overflow: hidden;
            border-radius: 50%;
            box-shadow: $box-shadow-base;
        }

        .convert-progress {
            float: left;
            left: 50%;
            margin-left: - 0.5 * $progress-width;
            background-color: $color-white-base;
            border-radius: 50%;
        }

        .background-image {
            width: 640px;
            margin: 0 auto;
            background-image: url("~@/assets/images/project-convert.png");
            background-size: contain;
        }
    }

    .hint {
        margin-top: $margin-base;
        line-height: 1.5;
    }

    .qrcode {
        position: absolute;
        top: 0;
        right: 20px;
        width: 140px;
        background-color: $color-gray-extreme-light;

        .img {
            position: relative;
            width: 100px;
            height: 100px;
            margin: 20px auto;
        }
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?725744e5